export default __webpack_public_path__ + "static/media/error@2x.d8330399.png";